export default __webpack_public_path__ + "static/media/ava-09.d8b78d4f.png";